let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("25Ymu")).then(() => parcelRequire('CwC9E'));